
import React from 'react';
import { Button } from '@/components/ui/button';
import { Eye } from 'lucide-react';
import { Product } from '@/lib/supabase/products/types';
import { useShopName } from '@/components/dashboard/products/hooks/useShopName';
import { useToast } from '@/components/ui/use-toast';

interface ProductShareLinkProps {
  product: Product;
}

const ProductShareLink = ({ product }: ProductShareLinkProps) => {
  const { shopName, shopSlug } = useShopName(product.shop_id);
  const { toast } = useToast();
  
  if (!product.shop_id) {
    return null;
  }
  
  // Create a slug from the product name
  const productSlug = product.name ? product.name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '') : '';
  
  // Format URL using the shop slug with the new structure: /shop/shop-slug/products/product-name-PRODUCTID
  const productUrl = `${window.location.origin}/shop/${shopSlug || shopName?.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}/products/${productSlug}-${product.id}`;
  
  const handleOpenPage = () => {
    try {
      console.log("Opening product URL:", productUrl);
      
      // Open the product page in a new tab
      window.open(productUrl, '_blank');
    } catch (error) {
      console.error("Error opening product page:", error);
      toast({
        title: "Erreur",
        description: "Impossible de visualiser ce produit",
        variant: "destructive",
      });
    }
  };
  
  return (
    <Button size="sm" variant="outline" className="ml-2" onClick={handleOpenPage}>
      <Eye className="h-4 w-4 mr-1" />
      Visualiser
    </Button>
  );
};

export default ProductShareLink;
